import { getCell, getSheetIndex, getSheetName } from '../base/index';
import { insertModel, workbookFormulaOperation, updateSheetFromDataSource, refreshChart, getSortedIndex } from '../../workbook/common/index';
import { insert, insertMerge, refreshClipboard, refreshInsertDelete } from '../../workbook/common/index';
import { updateRowColCount, beginAction, getRangeIndexes, getRangeAddress } from '../../workbook/common/index';
import { insertFormatRange } from '../../workbook/index';
/**
 * The `WorkbookInsert` module is used to insert cells, rows, columns and sheets in to workbook.
 */
export class WorkbookInsert {
    /**
     * Constructor for the workbook insert module.
     *
     * @param {Workbook} parent - Specifies the workbook.
     * @private
     */
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    // tslint:disable-next-line
    insertModel(args) {
        if (!args.model) {
            return;
        }
        let index;
        let model = [];
        let mergeCollection;
        let isModel;
        let maxHgtObj;
        if (typeof (args.start) === 'number') {
            index = args.start;
            args.end = args.end || index;
            if (index > args.end) {
                index = args.end;
                args.end = args.start;
            }
            if (args.modelType === 'Row' && index < args.model.maxHgts.length) {
                maxHgtObj = [];
            }
            for (let i = index; i <= args.end; i++) {
                model.push({});
                if (maxHgtObj) {
                    maxHgtObj.push(null);
                }
            }
        }
        else {
            if (args.start) {
                index = args.start[0].index || 0;
                model = args.start;
                isModel = true;
            }
            else {
                index = 0;
                model.push({});
            }
            if (args.modelType === 'Row' && index < args.model.maxHgts.length) {
                maxHgtObj = [];
                model.forEach(() => {
                    maxHgtObj.push(null);
                });
            }
        }
        const eventArgs = { model: model, index: index, modelType: args.modelType, insertType: args.insertType,
            cancel: false, isUndoRedo: args.isUndoRedo };
        const actionArgs = { eventArgs: eventArgs, action: 'insert' };
        if (args.isAction) {
            this.parent.notify(beginAction, actionArgs);
            if (eventArgs.cancel) {
                return;
            }
            delete eventArgs.cancel;
            eventArgs.isAction = args.isAction;
        }
        const insertArgs = { startIndex: index, endIndex: index + model.length - 1, modelType: args.modelType, sheet: args.model, isInsert: true };
        if (args.modelType === 'Row') {
            if (args.checkCount !== undefined && args.model.rows && args.checkCount === args.model.rows.length) {
                return;
            }
            this.parent.notify(refreshInsertDelete, insertArgs);
            args.model = args.model;
            if (!args.model.rows) {
                args.model.rows = [];
            }
            if (isModel && args.model.usedRange.rowIndex > -1 && index > args.model.usedRange.rowIndex) {
                for (let i = args.model.usedRange.rowIndex; i < index - 1; i++) {
                    model.splice(0, 0, {});
                }
            }
            const frozenRow = this.parent.frozenRowCount(args.model);
            if (index < frozenRow || (index <= frozenRow && args.freezePane)) {
                const newFrozenRows = args.model.frozenRows + model.length - ((index === frozenRow && frozenRow > 0) ? 1 : 0);
                this.parent.setSheetPropertyOnMute(args.model, 'frozenRows', newFrozenRows);
                eventArgs.freezePane = true;
            }
            args.model.rows.splice(index, 0, ...model);
            if (maxHgtObj) {
                args.model.maxHgts.splice(index, 0, ...maxHgtObj);
            }
            //this.setInsertInfo(args.model, index, model.length, 'count');
            this.setRowColCount(insertArgs.startIndex, insertArgs.endIndex, args.model, 'row');
            if (index > args.model.usedRange.rowIndex) {
                this.parent.setUsedRange(index + (model.length - 1), args.model.usedRange.colIndex, args.model, true);
            }
            else {
                this.parent.setUsedRange(args.model.usedRange.rowIndex + model.length, args.model.usedRange.colIndex, args.model, true);
            }
            const curIdx = index + model.length;
            let style;
            let cell;
            let newStyle;
            let parentCell;
            let mergeArgs;
            for (let i = 0; i <= args.model.usedRange.colIndex; i++) {
                if (args.model.rows[curIdx] && args.model.rows[curIdx].cells &&
                    args.model.rows[curIdx].cells[i]) {
                    cell = args.model.rows[curIdx].cells[i];
                    if (cell.rowSpan !== undefined && cell.rowSpan < 0 && cell.colSpan === undefined) {
                        mergeArgs = { range: [curIdx, i, curIdx, i], insertCount: model.length, insertModel: 'Row' };
                        this.parent.notify(insertMerge, mergeArgs);
                        if (!eventArgs.freezePane && mergeArgs.range[0] < frozenRow && mergeArgs.range[2] > frozenRow) {
                            eventArgs.freezePane = true;
                        }
                    }
                }
                parentCell = getCell(index - 1, i, args.model, false, true);
                style = parentCell.style;
                cell = getCell(index + 1, i, args.model, false, true);
                if (style || parentCell.wrap || parentCell.format) {
                    if (style) {
                        newStyle = {};
                        Object.keys(style).forEach((key) => {
                            if (!(key === 'borderLeft' || key === 'borderRight' || key === 'borderTop' || key === 'borderBottom')) {
                                newStyle[key] = style[key];
                            }
                        });
                        if (cell.style) {
                            this.checkBorder(cell.style, args.model.rows[index - 1].cells[i].style, newStyle);
                        }
                    }
                    if (!args.isUndoRedo || args.isRedo) {
                        model.forEach((row) => {
                            if (!row.cells) {
                                row.cells = [];
                            }
                            if (!row.cells[i]) {
                                row.cells[i] = {};
                            }
                            if (style) {
                                if (!row.cells[i].style) {
                                    row.cells[i].style = {};
                                }
                                Object.assign(row.cells[i].style, newStyle);
                            }
                            if (parentCell.wrap) {
                                row.cells[i].wrap = true;
                            }
                            if (parentCell.format) {
                                row.cells[i].format = parentCell.format;
                            }
                        });
                    }
                }
            }
            eventArgs.sheetCount = args.model.rows.length;
        }
        else if (args.modelType === 'Column') {
            if (args.checkCount !== undefined && args.model.columns && args.checkCount === args.model.columns.length) {
                return;
            }
            this.parent.notify(refreshInsertDelete, insertArgs);
            args.model = args.model;
            if (!args.model.columns) {
                args.model.columns = [];
            }
            if (index && !args.model.columns[index - 1]) {
                args.model.columns[index - 1] = {};
            }
            args.model.columns.splice(index, 0, ...model);
            const frozenCol = this.parent.frozenColCount(args.model);
            if (index < frozenCol || (index <= frozenCol && args.freezePane)) {
                const newFrozenCols = args.model.frozenColumns + model.length - ((index === frozenCol && frozenCol > 0) ? 1 : 0);
                this.parent.setSheetPropertyOnMute(args.model, 'frozenColumns', newFrozenCols);
                eventArgs.freezePane = true;
            }
            //this.setInsertInfo(args.model, index, model.length, 'fldLen', 'Column');
            this.setRowColCount(insertArgs.startIndex, insertArgs.endIndex, args.model, 'col');
            if (index > args.model.usedRange.colIndex) {
                this.parent.setUsedRange(args.model.usedRange.rowIndex, index + (model.length - 1), args.model, true);
            }
            else {
                this.parent.setUsedRange(args.model.usedRange.rowIndex, args.model.usedRange.colIndex + model.length, args.model, true);
            }
            if (!args.model.rows) {
                args.model.rows = [];
            }
            const cellModel = [];
            if (!args.columnCellsModel) {
                args.columnCellsModel = [];
            }
            for (let i = 0; i < model.length; i++) {
                cellModel.push(null);
            }
            mergeCollection = [];
            let cell;
            let style;
            let newStyle;
            let parentCell;
            for (let i = 0; i <= args.model.usedRange.rowIndex; i++) {
                if (!args.model.rows[i]) {
                    args.model.rows[i] = { cells: [] };
                }
                else if (!args.model.rows[i].cells) {
                    args.model.rows[i].cells = [];
                }
                if (index && !args.model.rows[i].cells[index - 1]) {
                    args.model.rows[i].cells[index - 1] = {};
                }
                args.model.rows[i].cells.splice(index, 0, ...(args.columnCellsModel[i] &&
                    args.columnCellsModel[i].cells ? args.columnCellsModel[i].cells : cellModel));
                const curIdx = index + model.length;
                cell = args.model.rows[i].cells[curIdx];
                if (cell && cell.colSpan !== undefined && cell.colSpan < 0 && cell.rowSpan === undefined) {
                    mergeCollection.push({
                        range: [i, curIdx, i, curIdx], insertCount: cellModel.length, insertModel: 'Column'
                    });
                }
                else if (args.isUndoRedo && !args.isRedo) {
                    let mergeIdx;
                    for (let colIdx = index; colIdx < curIdx; colIdx++) {
                        cell = args.model.rows[i].cells[colIdx];
                        if (cell && cell.colSpan !== undefined && cell.colSpan < 0 && cell.rowSpan === undefined) {
                            mergeIdx = colIdx;
                        }
                        else {
                            break;
                        }
                    }
                    if (mergeIdx) {
                        mergeCollection.push({ range: [i, mergeIdx, i, mergeIdx], insertCount: 0, insertModel: 'Column' });
                    }
                }
                parentCell = getCell(i, index - 1, args.model, false, true);
                style = parentCell.style;
                cell = getCell(i, index + 1, args.model, false, true);
                if (style || parentCell.wrap || parentCell.format) {
                    if (style) {
                        newStyle = {};
                        Object.keys(style).forEach((key) => {
                            if (!(key === 'borderLeft' || key === 'borderRight' || key === 'borderTop' || key === 'borderBottom')) {
                                newStyle[key] = style[key];
                            }
                        });
                        if (cell.style) {
                            this.checkBorder(cell.style, args.model.rows[i].cells[index - 1].style, newStyle);
                        }
                    }
                    if (!args.isUndoRedo || args.isRedo) {
                        for (let j = index; j < curIdx; j++) {
                            if (!args.model.rows[i].cells[j]) {
                                args.model.rows[i].cells[j] = {};
                            }
                            if (style) {
                                if (!args.model.rows[i].cells[j].style) {
                                    args.model.rows[i].cells[j].style = {};
                                }
                                Object.assign(args.model.rows[i].cells[j].style, newStyle);
                            }
                            if (parentCell.wrap) {
                                args.model.rows[i].cells[j].wrap = true;
                            }
                            if (parentCell.format) {
                                args.model.rows[i].cells[j].format = parentCell.format;
                            }
                        }
                    }
                }
            }
            mergeCollection.forEach((mergeArgs) => {
                this.parent.notify(insertMerge, mergeArgs);
                if (!eventArgs.freezePane && mergeArgs.range[1] < frozenCol && mergeArgs.range[3] > frozenCol) {
                    eventArgs.freezePane = true;
                }
            });
            eventArgs.sheetCount = args.model.columns.length;
        }
        else {
            if (args.checkCount !== undefined && args.checkCount === this.parent.sheets.length) {
                return;
            }
            const sheetModel = model;
            const sheetName = getSheetName(this.parent);
            const isFromUpdateAction = args.isFromUpdateAction;
            for (let i = 0; i < sheetModel.length; i++) {
                if (sheetModel[i].name) {
                    for (let j = 0; j < this.parent.sheets.length; j++) {
                        if (sheetModel[i].name === this.parent.sheets[j].name) {
                            sheetModel.splice(i, 1);
                            i--;
                            break;
                        }
                    }
                }
            }
            if (!sheetModel.length) {
                return;
            }
            delete model[0].index;
            this.parent.createSheet(index, model);
            let id;
            if (args.activeSheetIndex) {
                eventArgs.activeSheetIndex = args.activeSheetIndex;
                this.parent.setProperties({ activeSheetIndex: args.activeSheetIndex }, true);
            }
            else if (!args.isAction && args.start < this.parent.activeSheetIndex) {
                this.parent.setProperties({ activeSheetIndex: this.parent.skipHiddenSheets(this.parent.activeSheetIndex) }, true);
            }
            if (isFromUpdateAction) {
                this.parent.setProperties({ activeSheetIndex: getSheetIndex(this.parent, sheetName) }, true);
            }
            model.forEach((sheet) => {
                if (isModel) {
                    this.updateRangeModel(sheet.ranges);
                }
                const viewport = this.parent.viewport;
                const refreshRange = [viewport.topIndex, viewport.leftIndex, viewport.bottomIndex, viewport.rightIndex];
                const args = {
                    sheet: sheet, resolveAfterFullDataLoaded: true,
                    indexes: refreshRange, promise: new Promise((resolve) => { resolve((() => { })()); })
                };
                this.parent.notify(updateSheetFromDataSource, args);
                id = sheet.id;
                this.parent.notify(workbookFormulaOperation, {
                    action: 'addSheet', visibleName: sheet.name, sheetName: 'Sheet' + id, sheetId: id
                });
            });
            eventArgs.activeSheetIndex = args.activeSheetIndex;
            eventArgs.sheetCount = this.parent.sheets.length;
        }
        if (args.modelType !== 'Sheet') {
            this.insertConditionalFormats(args);
            const start = args.isUndoRedo ? insertArgs.startIndex : args.start;
            const end = args.isUndoRedo ? insertArgs.endIndex : args.end;
            this.insertComments(args, start, end);
            this.insertNotes(args, start, end);
            this.parent.notify(refreshClipboard, { start: index, end: index + model.length - 1, modelType: args.modelType, model: args.model, isInsert: true });
            eventArgs.activeSheetIndex = getSheetIndex(this.parent, args.model.name);
            if (this.parent.chartColl && this.parent.chartColl.length) {
                this.parent.notify(refreshChart, { range: getRangeIndexes(args.model.selectedRange) });
            }
        }
        this.parent.notify(insert, actionArgs);
    }
    setRowColCount(startIdx, endIdx, sheet, layout) {
        const prop = layout + 'Count';
        this.parent.setSheetPropertyOnMute(sheet, prop, sheet[`${prop}`] + ((endIdx - startIdx) + 1));
        if (sheet.id === this.parent.getActiveSheet().id) {
            this.parent.notify(updateRowColCount, { index: sheet[`${prop}`] - 1, update: layout, isInsert: true, start: startIdx, end: endIdx });
        }
    }
    updateRangeModel(ranges) {
        ranges.forEach((range) => {
            if (range.dataSource) {
                range.startCell = range.startCell || 'A1';
                range.showFieldAsHeader = range.showFieldAsHeader === undefined || range.showFieldAsHeader;
                range.template = range.template || '';
                range.address = range.address || 'A1';
            }
        });
    }
    checkBorder(style, adjStyle, newStyle) {
        if (style.borderLeft && style.borderLeft === adjStyle.borderLeft) {
            newStyle.borderLeft = style.borderLeft;
        }
        if (style.borderRight && style.borderRight === adjStyle.borderRight) {
            newStyle.borderRight = style.borderRight;
        }
        if (style.borderTop && style.borderTop === adjStyle.borderTop) {
            newStyle.borderTop = style.borderTop;
        }
        if (style.borderBottom && style.borderBottom === adjStyle.borderBottom) {
            newStyle.borderBottom = style.borderBottom;
        }
    }
    setInsertInfo(sheet, startIndex, count, totalKey, modelType = 'Row') {
        const endIndex = count = startIndex + (count - 1);
        sheet.ranges.forEach((range) => {
            if (range.info && startIndex < range.info[`${totalKey}`]) {
                if (!range.info[`insert${modelType}Range`]) {
                    range.info[`insert${modelType}Range`] = [[startIndex, endIndex]];
                }
                else {
                    range.info[`insert${modelType}Range`].push([startIndex, endIndex]);
                }
                range.info[`${totalKey}`] += ((endIndex - startIndex) + 1);
            }
        });
    }
    insertConditionalFormats(args) {
        const cfCollection = args.model.conditionalFormats;
        if (args.prevAction === 'delete') {
            this.parent.setSheetPropertyOnMute(args.model, 'conditionalFormats', args.conditionalFormats);
        }
        else if (cfCollection) {
            for (let i = 0, cfLength = cfCollection.length; i < cfLength; i++) {
                cfCollection[i].range = getRangeAddress(insertFormatRange(args, getRangeIndexes(cfCollection[i].range), !args.isAction && !args.isUndoRedo));
            }
        }
    }
    insertComments(args, startIdx, endIdx) {
        if (args.prevAction === 'delete') {
            const insertCount = (endIdx + 1) - startIdx;
            const existing = args.model.comments;
            for (let i = 0; i < existing.length; i++) {
                const comment = existing[i];
                if (args.modelType === 'Row' && comment.address[0] >= startIdx) {
                    comment.address[0] += insertCount;
                    const commentModel = getCell(comment.address[0], comment.address[1], args.model, null, true).comment;
                    if (commentModel) {
                        commentModel.address[0] = comment.address[0];
                    }
                }
                else if (args.modelType === 'Column' && comment.address[1] >= startIdx) {
                    comment.address[1] += insertCount;
                    const commentModel = getCell(comment.address[0], comment.address[1], args.model, null, true).comment;
                    if (commentModel) {
                        commentModel.address[1] = comment.address[1];
                    }
                }
            }
            for (let j = 0; j < args.comments.length; j++) {
                const restored = args.comments[j];
                const idx = getSortedIndex(args.model.comments, [restored.address[0], restored.address[1]], true);
                args.model.comments.splice(idx, 0, restored);
            }
            return;
        }
        const comments = args.model.comments;
        if (comments) {
            for (let i = 0; i < comments.length; i++) {
                const address = comments[i].address;
                if ((args.modelType === 'Row' && address[0] >= startIdx) || (args.modelType === 'Column' && address[1] >= startIdx)) {
                    const commentAddress = [address[0], address[1], address[0], address[1]];
                    const updatedaddress = insertFormatRange(args, commentAddress, !args.isAction && !args.isUndoRedo);
                    comments[i].address = [updatedaddress[2], updatedaddress[3]];
                    const comment = getCell(updatedaddress[2], updatedaddress[3], args.model, null, true).comment;
                    if (comment) {
                        comment.address = [updatedaddress[2], updatedaddress[3]];
                    }
                }
            }
        }
    }
    insertNotes(args, startIdx, endIdx) {
        if (args.prevAction === 'delete') {
            const insertCount = (endIdx + 1) - startIdx;
            const existing = args.model.notes;
            for (let i = 0; i < existing.length; i++) {
                const note = existing[i];
                if (args.modelType === 'Row' && note.rowIdx >= startIdx) {
                    note.rowIdx = note.rowIdx + insertCount;
                    const noteModel = getCell(note.rowIdx, note.colIdx, args.model, null, true).notes;
                    if (noteModel) {
                        noteModel.rowIdx = note.rowIdx;
                    }
                }
                else if (args.modelType === 'Column' && note.colIdx >= startIdx) {
                    note.colIdx = note.colIdx + insertCount;
                    const noteModel = getCell(note.rowIdx, note.colIdx, args.model, null, true).notes;
                    if (noteModel) {
                        noteModel.colIdx = note.colIdx;
                    }
                }
            }
            for (let j = 0; j < args.notes.length; j++) {
                const restored = args.notes[j];
                const idx = getSortedIndex(args.model.notes, [restored.rowIdx, restored.colIdx], false);
                args.model.notes.splice(idx, 0, restored);
            }
            return;
        }
        const notes = args.model.notes;
        if (notes) {
            for (let i = 0; i < notes.length; i++) {
                const note = notes[i];
                if ((args.modelType === 'Row' && note.rowIdx >= startIdx) || (args.modelType === 'Column' && note.colIdx >= startIdx)) {
                    const noteAddress = [note.rowIdx, note.colIdx, note.rowIdx, note.colIdx];
                    const updatedaddress = insertFormatRange(args, noteAddress, !args.isAction && !args.isUndoRedo);
                    notes[i].rowIdx = updatedaddress[2];
                    notes[i].colIdx = updatedaddress[3];
                    const noteModel = getCell(updatedaddress[2], updatedaddress[3], args.model, null, true).notes;
                    if (noteModel) {
                        noteModel.rowIdx = updatedaddress[2];
                        noteModel.colIdx = updatedaddress[3];
                    }
                }
            }
        }
    }
    addEventListener() {
        this.parent.on(insertModel, this.insertModel, this);
    }
    /**
     * Destroy workbook insert module.
     *
     * @returns {void} - destroy the workbook insert module.
     */
    destroy() {
        this.removeEventListener();
        this.parent = null;
    }
    removeEventListener() {
        if (!this.parent.isDestroyed) {
            this.parent.off(insertModel, this.insertModel);
        }
    }
    /**
     * Get the workbook insert module name.
     *
     * @returns {string} - Return the string.
     */
    getModuleName() {
        return 'workbookinsert';
    }
}
